const configHistory = {
    history: {
        listLayout: 'HistoryListDefaultLayout',
        filterLayout: 'HistoryFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getHistory',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    itemHistory: {
        listLayout: 'HistoryListItemLayout',
        getFunc: 'getItemHistory',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
    detectionRequestHistory: {
        listLayout: 'HistoryListDetectionRequestLayout',
        getFunc: 'getDetectionRequest',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },

}
import util from "@/mixins/util";

export default {
    methods: {
        returnHistoryConfig(type) {
            return configHistory[type];
        },

    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        al: {
            type: 'between',
            classname: 'filterDate'
        },
        out: {
            type: 'between',
            classname: 'filterOutDate'
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        bid: {
            type: 'query',
            classname: 'filterStatus',
        },
        bl: {
            type: 'match',
            classname: 'filterStatus',
        },
        cmty:{
            type: 'terms',
            classname: 'filterType',
        }

    }
}
